import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Typography } from "@mui/material";
import theme from "../../theme";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import { getCalendarEvent } from "../../api/calendarApi";

const ExamDeadlines = () => {
    const dispatch = useDispatch();
    const { loading, user } = useSelector((state) => state.auth);
    const [upcomingExams, setUpcomingExams] = useState([]);

    const getUpComingExam = async () => {
        try {
            dispatch(setLoading({ loading: true }));
            const response = await getCalendarEvent(user?.user_id, '');
            setUpcomingExams(response.data);
            dispatch(setLoading({ loading: false }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message ||
                err.response?.data?.message ||
                err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({ loading: false }));
        }
    }

    useEffect(() => {
        if (user?.student_id) {
            getUpComingExam();
        }
    }, [user]);

    return (
        <Fragment>
            {loading && (
                <LoadingSpinner />
            )}
            <CommonCard
                borderRadius={2}
                headerContent={
                    <Fragment>
                        <Box sx={{ padding: '17.5px 13px' }}>
                            <Typography fontWeight={600}>Upcoming Exams/Deadlines</Typography>
                            <Typography fontSize={14} color={theme.palette.background.dark}>View your upcoming application and exam deadlines.</Typography>
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    upcomingExams.length > 0 ?
                        (<Box
                            sx={{
                                height: '40vh',
                                overflow: 'auto'
                            }}
                        >
                            {upcomingExams?.map((a, index) => {
                                const deadlineDate = moment(a.event_start_timestamp);
                                const currentDate = moment();
                                const daysDifference = deadlineDate.diff(currentDate, 'days');
                                return (
                                    <CommonCard
                                        key={index}
                                        background={theme.palette.background.main}
                                        borderRadius={2}
                                        paddingBottom="0px"
                                        padding="13px"
                                        marginTop={index === 0 ? "0px" : "10px"}
                                        content={
                                            <Box
                                                display="flex"
                                                justifyContent="space-between"
                                            >
                                                <Box>
                                                    <Typography fontSize={14} fontWeight="600">{a.event_title}</Typography>
                                                    <Typography fontSize={14}>{a.event_category}</Typography>
                                                </Box>
                                                <Box>
                                                    <Box
                                                        sx={{
                                                            background: a.type === 1 ? '#FEF9C2' : '#FFE2E2',
                                                            textAlign: 'center',
                                                            padding: daysDifference > 0 ? '0 8px' : '0px',
                                                            marginBottom: 0.5,
                                                            borderRadius: 3,
                                                        }}
                                                    >
                                                        <Typography fontSize={13} color={a.type === 1 ? '#894B00' : 'red'}>{daysDifference <= 0 ? 'Past' : `${daysDifference} days left`}</Typography>
                                                    </Box>
                                                    <Typography fontSize={13} color={theme.palette.background.dark} textAlign='center'>{a.event_start_timestamp ? moment(a.event_start_timestamp).format('YYYY-MM-DD') : ''}</Typography>
                                                </Box>
                                            </Box>
                                        }
                                    />
                                )
                            })}
                        </Box>) : (
                            <Box
                                display="flex"
                                justifyContent="center"
                            >
                                <Typography color={theme.palette.background.dark}>No Exam/Deadlines Found</Typography>
                            </Box>
                        )
                }
                paddingBottom="0px"
                padding="13px"
                marginTop="0px"
            />
        </Fragment>
    )
}

export default ExamDeadlines;